console.log('Facebook Config Environment:', {
  appId: process.env.REACT_APP_FACEBOOK_APP_ID,
  hasSecret: !!process.env.REACT_APP_FACEBOOK_APP_SECRET
});

export const facebookConfig = {
  name: 'Facebook',
  apiVersion: 'v21.0',
  requiredScopes: [
    'pages_show_list',
    'pages_read_engagement',
    'pages_manage_posts',
    'pages_read_user_content',
    'public_profile',
    'email',
    'read_insights'
  ],
  authEndpoint: 'https://www.facebook.com/v21.0/dialog/oauth',
  tokenEndpoint: 'https://graph.facebook.com/v21.0/oauth/access_token',
  
  settings: {
    name: {
      type: 'text',
      label: 'Connection Name',
      required: true
    },
    pageId: {
      type: 'select',
      label: 'Facebook Page',
      required: true,
      loadOptions: 'getPages'
    }
  }
}; 